// @flow
import isEqual from 'lodash.isequal';
import isObject from 'lodash.isobject';

/**
 * @param obj1 - any type which compatible with lodash.isEqual arguments
 * @param obj2 - any type which compatible with lodash.isEqual arguments
 * @param optionalFields - array of keys to compare, keys which not presented in optionalFields will be ignored
 * @returns {boolean}
 */
export const shouldUpdate = (obj1: Object, obj2: Object, optionalFields: ?string[]): boolean => {
    // Check only presented in optionalFields
    if (optionalFields) {
        return optionalFields.some(field => (isObject(obj1[field])
            ? shouldUpdate(obj1[field], obj2[field])
            : obj1[field] !== obj2[field])
        );
    }

    return !isEqual(obj1, obj2);
};
